<template>
  <div class="okrItem">
    <b-container class="objective">
      <b-row>
        <div class="objective-detail">
          <objective :itemId="item.itemId" :detailView="true" :content="this.item.contentText" :progress="this.item.progress ? '' + this.item.progress : '0'" :setReadOnly="'false'" :objective="false" />
        </div>
      </b-row>
      <b-row :style="{'margin-top' : '1.0em'}">
        <b-col cols="2" class="text-left">
          <span v-if="item.isComplete" class="comp-label">{{$t('secStr')}}</span>
        </b-col>
        <b-col class="text-right">
          <label>{{ $t('startDateStr') }}:</label>
            <span>{{ ymdSlash(item.startDate) }}</span>
          <label>{{ $t('dueDateStr') }}:</label>
          <span>{{ ymdSlash(item.dueDate) }}</span>
        </b-col>
      </b-row>
    </b-container>
    <hr v-if="item.keyresults && Object.values(item.keyresults).filter(x => this.targetDate >= x.startDate).length > 0">
    <template v-for="(kr, krId) in keyResultStartDate">
      <b-container class="keyresult" :key="krId">
        <b-row>
          <div class="objective-detail">
            <objective :itemId="krId" :detailView="true" :content="kr.contentText" :progress="kr.progress ? '' + kr.progress : '0'" :setReadOnly="'false'" :objective="false" />
          </div>
        </b-row>
        <b-row :style="{'margin-top' : '1.0em'}">
          <b-col cols="2" class="text-left">
            <span v-if="kr.isComplete" class="comp-label">{{$t('secStr')}}</span>
          </b-col>
          <b-col class="text-right">
            <span class="createDate">
            <label>{{ $t('startDateStr') }}:</label>
              <span>{{ ymdSlash(kr.startDate) }}</span>
            </span>
            <label>{{ $t('dueDateStr') }}:</label>
            <span>{{ ymdSlash(kr.dueDate) }}</span>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import Objective from '@/components/Okr/Objective'

export default {
  name: 'Report1on1ListOkrItem',
  components: {
    Objective
  },
  props: {
    item: {
      type: Object
    },
    targetDate: {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      targetUser: this.$store.state.currentUserId,
      progress: this.item.progress || 0
    }
  },
  getters: {
  },
  computed: {
    getProgress () {
      return this.item.progress || 0
    },
    ...mapGetters([
      'getKeyresultsByUser'
    ]),
    ...mapGetters('keyResults/', [
      'getKeyresults'
    ]),
    keyResultStartDate: function () {
      if (this.item && this.item.hasOwnProperty('keyresults') && this.item.keyresults) {
        let krs = {}
        Object.keys(this.item.keyresults)
          .filter(x => this.item.keyresults[x].hasOwnProperty('startDate') && this.targetDate >= this.item.keyresults[x].startDate)
          .forEach(kr => {
            krs[kr] = this.item.keyresults[kr]
          })
        return krs
      }
    }
  },
  methods: {
    ymdSlash: function (date) {
      const ymd = moment(String(date)).format('YYYY/MM/DD')
      return (ymd === 'Invalid date') ? '----/--/--' : ymd
    },
    jump: function (value, itemType) {
      console.log(' this.$emit(get-detail)', value, itemType)
      if (itemType) {
        value.type = {}
        value.type[itemType] = value.itemId || ''
      }
      this.$emit('open-detail', value)
    }
  },
  filters: {
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
a:hover{
  text-decoration: none;
}
.okrItem {
  dl {
    dt, dd { display: inline-block; }
  }
  .container {
    padding: 0;
    cursor: pointer;
    transition: .2s;
    border: 3px solid transparent;
    .btn-open-detail {
      display: none;
      position: absolute;
      top: 1.2em;
      right: 1.2em;
      z-index: 999;
    }
    &:hover {
      transition: .2s;
      .btn-open-detail {
        display: block;
      }
    }
  }
  .objective {
    display: block;
    &:hover {
      // border-color: #333399;
      box-shadow: 0 0 .1em .3em #333399;
    }
  }
  .keyresult {
    padding-left: 2em;
    &:hover {
      // border-color: #6666ff;
      box-shadow: 0 0 .1em .3em #6666ff;
    }
  }
  .createDate{
    // color: #CDCDCF;
    margin-right: 10px;
  }
  .objective-str{
    color: #4789b3;
    font-size: 1.1em;
    font-weight: 600;
  }
  .objective-detail{
    margin: 0 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Report/Report1on1ListOkrItem.vue